import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/store';
import App from './App';

// Prefer recaptcha.net over google.com for more reliable regional loading
// (must be set before any ReCAPTCHA widget mounts).
window.recaptchaOptions = {
  useRecaptchaNet: true,
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);